import {
  GET_FINANCE_REPORT,
  GET_FINANCE_REPORT_DETAIL_LIST,
  GET_FINANCE_REPORT_DETAIL_LIST_FAIL,
  GET_FINANCE_REPORT_DETAIL_LIST_SUCCESS,
  GET_FINANCE_REPORT_FAIL,
  GET_FINANCE_REPORT_SUCCESS,
  GET_SERVICE_REPORT,
  GET_SERVICE_REPORT_FAIL,
  GET_SERVICE_REPORT_SUCCESS,
  RESET_FINANCE_REPORT_FLAG,
  RESET_FINANCE_REPORT_LST,
  UPDATE_FINANCE_REPORT_DETAIL,
  UPDATE_FINANCE_REPORT_DETAIL_FAIL,
  UPDATE_FINANCE_REPORT_DETAIL_SUCCESS,
  UPSERT_FINANCE_REPORT,
  UPSERT_FINANCE_REPORT_FAIL,
  UPSERT_FINANCE_REPORT_SUCCESS,
} from "./actionTypes"

//-----------------------------------------------------finance report

export const upsertFinanceReport = data => ({
  type: UPSERT_FINANCE_REPORT,
  payload: data,
})

export const upsertFinanceReportSuccess = event => ({
  type: UPSERT_FINANCE_REPORT_SUCCESS,
  payload: event,
})

export const upsertFinanceReportFail = error => ({
  type: UPSERT_FINANCE_REPORT_FAIL,
  payload: error,
})

//-----------------------------------------------------get  finance report
export const getFinanceReport = () => ({
  type: GET_FINANCE_REPORT,
})

export const getFinanceReportSuccess = events => ({
  type: GET_FINANCE_REPORT_SUCCESS,
  payload: events,
})
export const getFinanceReportFail = error => ({
  type: GET_FINANCE_REPORT_FAIL,
  payload: error,
})

//-----------------------------------------------------get  finance report detail
export const getFinanceReportDetailList = values => ({
  type: GET_FINANCE_REPORT_DETAIL_LIST,
  payload: values,
})

export const getFinanceReportDetailListSuccess = events => ({
  type: GET_FINANCE_REPORT_DETAIL_LIST_SUCCESS,
  payload: events,
})
export const getFinanceReportDetailListFail = error => ({
  type: GET_FINANCE_REPORT_DETAIL_LIST_FAIL,
  payload: error,
})

  //-----------------------------------------------------Update finance report detail
  export const updateFinanceReportDetail = data => ({
    type: UPDATE_FINANCE_REPORT_DETAIL,
    payload: data,
  })
  
  export const updateFinanceReportDetailSuccess = event => ({
    type: UPDATE_FINANCE_REPORT_DETAIL_SUCCESS,
    payload: event,
  })
  export const updateFinanceReportDetailFail = error => ({
    type: UPDATE_FINANCE_REPORT_DETAIL_FAIL,
    payload: error,
  })


  //-----------------------------------------------------Reset
export const resetFinanceReportLst = () => {
  return {
    type: RESET_FINANCE_REPORT_LST,
  }
}


//-----------------------------------------------------get  service report
export const getServiceReport = data => ({
  type: GET_SERVICE_REPORT,
  payload: data,

})

export const getServiceReportSuccess = events => ({
  type: GET_SERVICE_REPORT_SUCCESS,
  payload: events,
})
export const getServiceReportFail = error => ({
  type: GET_SERVICE_REPORT_FAIL,
  payload: error,
})

//-----------------------------------------------------Reset
export const resetFinanceReportFlag = () => {
  return {
    type: RESET_FINANCE_REPORT_FLAG,
  }
}
